import {Component, Input} from '@angular/core';

@Component({
  selector: 'enhance-service-item',
  templateUrl: './enhance-service-item.component.html',
  styleUrls: ['./enhance-service-item.component.scss']
})
export class EnhanceServiceItemComponent {
  @Input() title: string = '';
  @Input() subtitle: string = '';
  @Input() image: string = '';
  @Input() direction: string = 'left';
}
